import {post} from '@/utils/request';
import{erpserver,erpplatserver,attendanceserver} from '@/utils/baseUrl';

//列表
export async function overtimeList(params) {
    return post(attendanceserver+'/attendence/overtimeList', params, true)
}
//搜索框模糊查询
export async function searchUser(params) {
    return post(attendanceserver+'/attendence/searchUser', params, true)
}
//保存
export async function saveOvertime(params) {
    return post(attendanceserver+'/attendence/saveOvertime', params, true)
}
//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}
//获取报表时间
export async function time(params) {
    return post(attendanceserver+'/attendence/kqtc/time', params, true)
}
//下载明细合计
export async function getExcel(params) {
    return post(attendanceserver+'/attendence/getExcel', params, true)
}


//new--------------------------------------------------------------------------

//主列表
export async function getOvertimeSqList(params) {
    return post(attendanceserver+'/attendence/getOvertimeSqList', params, true)
}
//子列表
export async function getOvertimeSqSubList(params) {
    return post(attendanceserver+'/attendence/getOvertimeSqSubList', params, true)
}
//异常子列表
export async function listOvertimeExcept(params) {
    return post(attendanceserver+'/attendence/listOvertimeExcept', params, true)
}
//保存
export async function saveOvertimeSq(params) {
    return post(attendanceserver+'/attendence/saveOvertimeSq', params, true)
}
//生成附件
export async function getOvertimeSqPdf(params) {
    return post(attendanceserver+'/attendence/getOvertimeSqPdf', params, true)
}
//保存补卡
export async function saveOvertimeBk(params) {
    return post(attendanceserver+'/attendence/saveOvertimeBk', params, true)
}
//生成补卡附件
export async function getOvertimeBkPdf(params) {
    return post(attendanceserver+'/attendence/getOvertimeBkPdf', params, true)
}
//扫码
export async function approveOvertimeSq(params) {
    return post(attendanceserver+'/attendence/approveOvertimeSq', params, true)
}
